// Reembolsos de enganche de la tienda del token (`GET /portal/pending-refunds`).
import { useQuery } from '@tanstack/react-query';
import { portalRefundsClient } from '@/api/services/retail-wizard/portalRefunds.client';
import { useAuthStore } from '@/stores/authStore';

export const STORE_REFUNDS_KEY = ['sales', 'pending-refunds'] as const;

export function useStoreRefunds() {
    // El silo responde por el token: la clave lleva al usuario para no servirle a otro su caché.
    const userId = useAuthStore((state) => state.user?.cognitoSub ?? null);
    return useQuery({
        queryKey: [...STORE_REFUNDS_KEY, userId],
        queryFn: () => portalRefundsClient.list(),
        staleTime: 30_000,
    });
}
